import { render, staticRenderFns } from "./ReportPendenciesPage.vue?vue&type=template&id=67ca6034&scoped=true"
import script from "./ReportPendenciesPage.vue?vue&type=script&lang=js"
export * from "./ReportPendenciesPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ReportPendenciesPage.vue?vue&type=style&index=1&id=67ca6034&prod&lang=scss&scoped=true"
import style2 from "./ReportPendenciesPage.vue?vue&type=style&index=2&id=67ca6034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca6034",
  null
  
)

export default component.exports